import React, { useEffect } from 'react'
import { observer } from "mobx-react-lite"
import { Redirect } from "@reach/router"
import FadeTransitionRouter from '../../components/FadeTransitionRouter'

import Login from './Login'
import Signup from './Signup'
import ForgotPassword from './ForgotPassword'
import Whoops from './Whoops'
import classes from './Auth.module.scss'
import usePlayer from '../common/usePlayer';


const Auth = observer(() => {
  const player = usePlayer()
  useEffect(() => {
    player.playType(null)
  }, [])

  return <div className={classes.root}>
    <div className={classes.wrapper}></div>
    <FadeTransitionRouter>
      <Login path="login" />
      <Signup path="signup" />
      <ForgotPassword path="forgot-password" />
      <Whoops path="whoops" />
      <Redirect from="*" to="/404" noThrow />
    </FadeTransitionRouter>
  </div>
})

export default Auth;